import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAdmin, isBetaUser, isContentCreator, isContentManager, isSuperAdmin, isUser } from 'app/utils/authUtilities';
import useStore, { IStore } from 'app/store';
import { UserDto } from 'generated/article-backend';

// Strongly typing all possible props for the routes would be overly restrictive, so we will allow the use of 'any' here.
export const AdminRoute: React.FC<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: React.FC<any>;
    path: string | string[];
    exact?: boolean;
}> = (props) => {
    const userDetails: UserDto = useStore((state: IStore) => state.userDetails);

    const condition = isAdmin(userDetails?.userRoles) || isSuperAdmin(userDetails?.userRoles);
    return condition ? <Route path={props.path} exact={props.exact} component={props.component} /> : <Redirect to="/404" />;
};
export const UserRoute: React.FC<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: React.FC<any>;
    path: string | string[];
    exact?: boolean;
}> = (props) => {
    const userDetails: UserDto = useStore((state: IStore) => state.userDetails) as UserDto;
    const condition =
        isUser(userDetails?.userRoles) ||
        isSuperAdmin(userDetails?.userRoles) ||
        isAdmin(userDetails?.userRoles) ||
        isContentCreator(userDetails?.userRoles) ||
        isContentManager(userDetails?.userRoles);
    return condition ? <Route path={props.path} exact={props.exact} component={props.component} /> : <Redirect to="/404" />;
};

export const SuperAdminRoute: React.FC<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: React.FC<any>;
    path: string | string[];
    exact?: boolean;
}> = (props) => {
    const userDetails: UserDto = useStore((state: IStore) => state.userDetails);

    const condition = isSuperAdmin(userDetails?.userRoles);
    return condition ? <Route path={props.path} exact={props.exact} component={props.component} /> : <Redirect to="/404" />;
};
export const ContentCreatorRoute: React.FC<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: React.FC<any>;
    path: string | string[];
    exact?: boolean;
}> = (props) => {
    const userDetails: UserDto = useStore((state: IStore) => state.userDetails) as UserDto;

    const condition =
        isContentCreator(userDetails?.userRoles) ||
        isContentManager(userDetails?.userRoles) ||
        isSuperAdmin(userDetails?.userRoles);
    return condition ? <Route path={props.path} exact={props.exact} component={props.component} /> : <Redirect to="/404" />;
};
export const ContentManagerRoute: React.FC<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: React.FC<any>;
    path: string | string[];
    exact?: boolean;
}> = (props) => {
    const userDetails: UserDto = useStore((state: IStore) => state.userDetails);

    const condition = isContentManager(userDetails?.userRoles) || isSuperAdmin(userDetails?.userRoles);
    return condition ? <Route path={props.path} exact={props.exact} component={props.component} /> : <Redirect to="/404" />;
};

export const BetaUserRoute: React.FC<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: React.FC<any>;
    path: string | string[];
    exact?: boolean;
}> = (props) => {
    const userDetails: UserDto = useStore((state: IStore) => state.userDetails);

    const condition = isBetaUser(userDetails?.userRoles);
    return condition ? <Route path={props.path} exact={props.exact} component={props.component} /> : <Redirect to="/404" />;
}